import type React from "react";

export function UploadImageIcon({ size = 16 }: { size?: number }): React.ReactNode {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      fill="none"
      viewBox="0 0 16 15"
      className="shrink-0"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M14.667 7.667v2.066c0 1.494 0 2.24-.29 2.811-.257.502-.665.91-1.166 1.165C12.64 14 11.893 14 10.4 14H5.6c-1.493 0-2.24 0-2.81-.29a2.667 2.667 0 01-1.166-1.166c-.29-.57-.29-1.317-.29-2.81V6.266c0-1.494 0-2.24.29-2.811.256-.502.664-.91 1.165-1.165C3.36 2 4.107 2 5.6 2h2.733m4.334 3.333v-4m-2 2h4m-4 4.667a2.667 2.667 0 11-5.334 0 2.667 2.667 0 015.334 0z"
      />
    </svg>
  );
}
